import { useEffect } from "react";

import { useAuth } from "../auth/AuthProvider";
import { GuideContent } from "../guide/GuideModal";

const scrollToHash = () => {
  try {
    const id = decodeURIComponent(window.location.hash.slice(1));
    if (id) {
      document.getElementById(id)?.scrollIntoView?.();
    }
  } catch {
    // A malformed fragment is ignored.
  }
};

/** Kept for direct links and old bookmarks; the header opens a dialog instead. */
export const GuidePage = () => {
  const auth = useAuth();
  const session =
    auth.state.status === "authenticated" ? auth.state.session : null;

  useEffect(() => {
    scrollToHash();
    window.addEventListener("hashchange", scrollToHash);
    return () => window.removeEventListener("hashchange", scrollToHash);
  }, []);

  if (!session) {
    return null;
  }

  return (
    <section className="canvaschool-page canvaschool-guide-page">
      <h1>사용 가이드</h1>
      <GuideContent
        page
        userId={session.principal.userId}
        isTeacher={session.principal.role === "TEACHER"}
        profileClassId={session.studentProfile?.classId}
      />
    </section>
  );
};
